import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { WashingMachine, Wind, Shirt, BedDouble, Truck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

const ICONS = { washing: WashingMachine, wind: Wind, iron: Shirt, bed: BedDouble, truck: Truck };

export const ServicesGrid = () => {
  const [services, setServices] = useState([]);

  useEffect(() => {
    api.get("/services").then(({ data }) => setServices(data)).catch(() => {});
  }, []);

  return (
    <section id="servicios" className="py-16 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="max-w-2xl mb-10 sm:mb-14">
          <h2 className="text-3xl sm:text-4xl font-heading font-bold text-slate-900">Nuestros Servicios</h2>
          <p className="mt-3 text-slate-600">
            Precios claros y sin sorpresas. Elige lo que necesitas y nosotros nos encargamos del resto.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-8" data-testid="services-grid">
          {services.map((s, i) => {
            const Icon = ICONS[s.icon] || WashingMachine;
            return (
              <div
                key={s.id}
                data-testid={`service-card-${s.id}`}
                className="hover-lift bg-white border border-slate-200 rounded-2xl p-5 sm:p-8 fade-up flex sm:block gap-4"
                style={{ animationDelay: `${i * 0.08}s` }}
              >
                <span className="inline-flex items-center justify-center h-12 w-12 rounded-xl bg-cyan-50 text-cyan-600 shrink-0 sm:mb-5">
                  <Icon className="h-6 w-6" />
                </span>
                <div>
                  <h3 className="font-heading font-semibold text-lg text-slate-900 leading-snug">{s.name}</h3>
                  <p className="mt-1.5 sm:mt-2 text-sm text-slate-600">{s.description}</p>
                  <p className="mt-3 sm:mt-4">
                    <span className="font-heading font-bold text-2xl text-cyan-600">{s.price.toFixed(2)} €</span>
                    <span className="text-sm text-slate-500 ml-1">{s.unit}</span>
                  </p>
                </div>
              </div>
            );
          })}
        </div>
        <div className="mt-10 sm:mt-12 text-center">
          <Button asChild size="lg" data-testid="services-reservar-btn" className="bg-cyan-500 hover:bg-cyan-600 rounded-full px-10 h-12 w-full sm:w-auto">
            <Link to="/reservar">Reservar Ahora</Link>
          </Button>
        </div>
      </div>
    </section>
  );
};
